import { useFormContext } from "react-hook-form";
import { getFromStatisticsAdsCampaign } from "../../../../../services/adsCampaigns";
import { LINKEDIN } from "../../../../../utils/constants";
import {
  VALUE_NUMBER,
  VALUE_WITH_PERCENTAGE,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_ASSETS_GROUP,
  IMPRESSIONS,
  RESULTS,
  CTR,
  CLICKS,
} from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import { openLink } from "../../../../../utils/string";
import PerformingAssetsCard from "../components/PerformingAssetsCard";
import PerformingAssetsBento, {
  PerformingAssetsBentoItem,
} from "../components/PerformingAssetsBento";
import { buildPerformingAssetSummary } from "../components/buildPerformingAssetSummary";
import {
  canShowPerformingEntity,
  findCampaignEntityByID,
} from "../components/performingAssetsMetrics";

const LinkedInPerformingAssets = () => {
  const { t } = useTranslationApp();
  const { campaign, campaignID } = useFormContext();
  const { statistics } = getFromStatisticsAdsCampaign(campaign);

  // Returns the best assets group, prioritizing mainAction, otherwise by click
  const getBestAssetsGroup = (assetsGroupsStatistics) => {
    if (!assetsGroupsStatistics) return null;

    let bestByMainAction = null;
    let bestByClick = null;
    let hasMainAction = false;

    Object.entries(assetsGroupsStatistics).forEach(([assetsGroupId, stats]) => {
      if (!stats) return;
      if (stats.mainAction && stats.mainAction > 0) {
        hasMainAction = true;
        if (
          !bestByMainAction ||
          stats.mainAction > bestByMainAction.statistics.mainAction
        ) {
          bestByMainAction = {
            assetsGroupId,
            statistics: stats,
          };
        }
      }
      if (
        !bestByClick ||
        (stats.click || 0) > (bestByClick.statistics.click || 0)
      ) {
        bestByClick = {
          assetsGroupId,
          statistics: stats,
        };
      }
    });

    return hasMainAction ? bestByMainAction : bestByClick;
  };

  const linkedInStats = statistics?.[LINKEDIN] ?? {};
  const bestAssetsGroup = getBestAssetsGroup(linkedInStats.assetsGroups);

  const getAssetsGroupByID = (id) => {
    const assetsGroup = findCampaignEntityByID({
      entities: campaign?.assetsGroups,
      id,
    });
    if (!assetsGroup?.id) return {};
    return { assetsGroup, assetsGroupID: assetsGroup.id };
  };

  const { assetsGroup = {}, assetsGroupID } = getAssetsGroupByID(
    bestAssetsGroup?.assetsGroupId
  );

  const showBestAssetsGroup = canShowPerformingEntity({
    entity: assetsGroup,
    statistics: bestAssetsGroup?.statistics,
  });

  const bestAssetsGroupStats = showBestAssetsGroup
    ? buildPerformingAssetSummary({
        t,
        statistics: bestAssetsGroup.statistics,
        impressionsLabel: t(IMPRESSIONS),
        ctrLabel: t(CTR),
        clicksLabel: t(CLICKS),
        resultsLabel: t(RESULTS),
        valueNumber: VALUE_NUMBER,
        valuePercentage: VALUE_WITH_PERCENTAGE,
      })
    : [];

  if (!showBestAssetsGroup) return null;

  return (
    <PerformingAssetsBento>
      <PerformingAssetsBentoItem span={6}>
        <PerformingAssetsCard
          platform={LINKEDIN}
          title={t(
            ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_ASSETS_GROUP
          )}
          subtitle={assetsGroup.name}
          onSubtitleClick={() =>
            openLink(
              `ads-campaign?campaignID=${campaignID}&platform=${LINKEDIN}&assetsGroupID=${assetsGroupID}`
            )
          }
          statistics={bestAssetsGroupStats}
        />
      </PerformingAssetsBentoItem>
    </PerformingAssetsBento>
  );
};

export default LinkedInPerformingAssets;
